/**
 *  状态和类型的config.js
 */

module.exports = {
  // 通用状态
  partnerConfig: {
    name: '智慧食堂 • 睿景在行',
  },
  status: { 1: '启用', 2: '禁用' },
  sopStatus: { 'UNHANDLE': '待跟进', 'UNDER_WAY': '跟进中', 'STOP': '已结束', 'FINISH': '已暂停' },
  paytypes: { 'ALIPAY': '支付宝', 'WEICHAT': '微信', 'CARD': '餐卡' },    //s2信息采集 - 支付方式
  subsidy_paytype: { 'ALIPAY': '支付宝方式支付扣补贴', 'CARD': '餐卡扣补贴', 'ALIPAY_CARD': '支付宝方式支付+餐卡支付扣补贴', 'OTHER': '其他方式' },    //s2信息采集 - 补贴扣费方式
  income_channel: { 'SELF': '自有通道', 'RUIJING': '睿景通道' },    //s2信息采集 - 收款通道
  dev_resoure: { 'SELF': '自购', 'RUIJING': '睿景渠道' },    //s2信息采集 - 海马和D2设备来源
  dev_type: { 'D2': 'D2收银设备', 'HM': '海马收银设备', 'OTHER': '除海马和D2外的，其他智能设备' },    //s2信息采集 - 需要的收银设备
  statusManger: {
    SUCCESS: '同步成功',
    FAIL: '同步失败',
    UNHANDLE: '同步未处理'
  },
  payStatusList: { "小计": "小计", 1: '会员卡补贴', 2: '会员卡现金', 4: '微信', 5: '支付宝' },
  orderStatusList: { 6: '支付成功', 7: '退款中', 8: '退款成功', 9: '退款失败' },
  payStatus: { wait: '待支付', success: '支付成功', fail: '支付失败', paying: '支付中', close: '已关闭' },
  isface: { 1: '是', 2: '否' },
  typeList: { 1: "门禁", 2: "消费", 3: "缴费", 4: "其他" },
  devType: {
    2: '收银机',
    3: '后厨接单机',
    4: '销号机',
    5: '取号显示屏',
    6: '应急机',
    9: '便利店收银',
    10: '便利店应急',
    11: '便利店上货',
    13: '保温柜',
    16: '芯烨打印机',
    17: '云喇叭',
    18: '门禁/考勤机',
    19: '牛奶机',
    20: '视频话机'
  },    //1: '服务器',7: '人脸识别机',8: '摄像头',12: '自助售货柜',14: '飞蛾打印机',15: '商米打印机',
  devTypeArr: [
    { value: 2, label: "收银机" },
    { value: 3, label: "后厨接单机" },
    { value: 4, label: "销号机" },
    { value: 5, label: "取号显示屏" },
    { value: 6, label: "应急机" },
    { value: 9, label: "便利店收银" },
    { value: 10, label: "便利店应急" },
    { value: 11, label: "便利店上货" },
    { value: 13, label: "保温柜" },
    { value: 16, label: "芯烨打印机" },
    { value: 17, label: "云喇叭" },
    { value: 18, label: "门禁/考勤机" },
    { value: 19, label: "牛奶机" },
    { value: 20, label: "视频话机" }
  ],
  devStatus: { 2: '启用', 3: '禁用', 4: '报修', 5: '维修中', 6: '已报废' },    //1: '待启用'
  devStatusArr: [
    { value: 2, label: "启用" },
    { value: 3, label: "禁用" },
    { value: 4, label: "报修" },
    { value: 5, label: "维修中" },
    { value: 6, label: "已报废" },
  ],    //1: '待启用'
  //设备应用场景
  scenetype: {
    1: '宿舍楼',
    2: '学校大门口',
    3: '图书馆',
  },
  scenetypeArr: [
    { value: 2, label: "学校大门口" },
    { value: 1, label: "宿舍楼" },
    { value: 3, label: "图书馆" },
  ],
  schoolStatus: {
    1: '待支付',
    2: '已取消',
    3: '支付中',
    4: '支付失败',
    5: '支付成功',
    6: '退款中',
    7: '退款失败',
    8: '退款成功',
  },
  schoolPay: {
    1: '支付宝',
    2: '银行卡',
  },
  invoiceStatusArr: [{ id: 1, label: '是' }, { id: 2, label: '否' }],
  //订单状态
  orderRecharge: { 1: '支付中', 2: '支付失败', 3: '支付成功', 4: '已退款', 5: '退款中', 6: '退款失败' },
  //充值支付方式
  rechargePayType: { 1: '微信', 2: '支付宝', 3: '补贴', 4: '现金', 5: '次数' },
  rechargeType: { 1: 'POS充值', 2: '手机充值', 3: '批量补贴' },
  invoiceStatusObj: { 1: '是', 2: '否' },
  moneyType: {
    1: 'POS补贴充值',
    2: '批量补贴充值（餐厅）',
    3: 'POS现金充值',
    4: '线上现金充值',
    5: 'POS消费',
    6: '堂食消费',
    7: '自提消费',
    8: 'POS订单退款',
    9: '堂食退款',
    10: '自提退款',
    11: 'POS补贴充值退款',
    12: '批量补贴充值退款（餐厅）',
    13: '注销退款',
    14: '便利店消费',
    15: '商城消费',
    16: '商城退款',
    17: '一键清空补贴（餐厅）',
    18: '便利店退款',
    19: '外卖消费',
    20: '外卖退款',
    21: '自助售货柜消费',
    22: '自助售货柜退款',
    23: '线下充值次数',
    24: '批量充值次数（餐厅）',
    25: '线下充值次数撤销',
    26: '批量充值次数撤销（餐厅）',
    27: '一键次数清空（餐厅）',
    28: '医院点餐消费',
    29: '医院点餐退款',
    30: '批量补贴充值（甲方）',
    31: '批量补贴充值撤销（甲方）',
    32: '批量充值次数（甲方）',
    33: '批量充值次数撤销（甲方）',
    34: '一键次数清空（甲方）',
    35: '一键补贴清空（甲方）【修改】',
    36: '家宴支付',
    37: '家宴退款',
    38: '包房支付',
    39: '包房退款',
    40: '供应链便利店消费',
    41: '供应链便利店退款',
    42: '扫码点餐消费',
    43: '扫码点餐退款',
    44: 'k12充值',
    45: 'k12退款',
    46: '批量现金充值（餐厅）',
    47: '批量现金充值撤销（餐厅）',
    48: '批量临时补助现金充值（餐厅）',
    49: '批量临时补助现金充值撤销（餐厅）',
    50: '商城消费',
    51: '商城退款',
    52: 'k12批量清零',
    // 新增类型 by 冯橹宇 2024-02-04
    53: '电子充值',
    54: '迁移充值',
    55: '实体充值',
    56: '电子消费',
    57: '迁移消费',
    58: '实体消费',
    59: '电子退款',
    60: '迁移退款',
    61: '实体退款',
    62: '红包消费',
    63: '红包退款',
    64: '三方支付',
    65: '三方退款',
    66: '余额卡密消费',
    67: '余额卡密退款',
    68: '红包充值',
    999: 'POS现金充值退款',
    // 新增类型 by 张丽娜 2024-06-22
    69: '卡密清零',
    70: '卡密撤销',
    71: '便利店线上消费',
    72: '实体卡作废',
    73: '卡密激活（仅实体卡）',
    74: '注销清零',
    75: '红包消费',
    76: '红包退款',
  },    //type
  moneyTypeArr: [
    { value: 1, label: "POS补贴充值" },
    { value: 11, label: "POS补贴充值退款" },
    { value: 3, label: "POS现金充值" },
    { value: 999, label: "POS现金充值退款" },
    { value: 5, label: "POS消费" },
    { value: 8, label: "POS订单退款" },
    { value: 6, label: "堂食消费" },
    { value: 9, label: "堂食退款" },
    { value: 7, label: "自提消费" },
    { value: 10, label: "自提退款" },
    { value: 14, label: "便利店消费" },
    { value: 18, label: "便利店退款" },
    { value: 15, label: "商城消费" },
    { value: 16, label: "商城退款" },
    { value: 19, label: "外卖消费" },
    { value: 20, label: "外卖退款" },
    { value: 36, label: "家宴支付" },
    { value: 37, label: "家宴退款" },
    { value: 38, label: "包房支付" },
    { value: 39, label: "包房退款" },
    { value: 13, label: "注销退款" },
    { value: 4, label: "线上现金充值" },
    { value: 17, label: "一键清空补贴（餐厅）" },
    { value: 2, label: "批量补贴充值（餐厅）" },
    { value: 12, label: "批量补贴充值退款（餐厅）" },
    { value: 27, label: "一键次数清空（餐厅）" },
    { value: 24, label: "批量充值次数（餐厅）" },
    { value: 26, label: "批量充值次数撤销（餐厅）" },
    { value: 46, label: "批量现金充值（餐厅）" },
    { value: 47, label: "批量现金充值撤销（餐厅）" },
    { value: 48, label: "批量临时补助现金充值（餐厅）" },
    { value: 49, label: "批量临时补助现金充值撤销（餐厅）" },
    { value: 21, label: "自助售货柜消费" },
    { value: 22, label: "自助售货柜退款" },
    { value: 23, label: "线下充值次数" },
    { value: 25, label: "线下充值次数撤销" },
    { value: 28, label: "医院点餐消费" },
    { value: 29, label: "医院点餐退款" },
    { value: 30, label: "批量补贴充值（甲方）" },
    { value: 31, label: "批量补贴充值撤销（甲方）" },
    { value: 32, label: "批量充值次数（甲方）" },
    { value: 33, label: "批量充值次数撤销（甲方）" },
    { value: 34, label: "一键次数清空（甲方）" },
    { value: 35, label: "一键补贴清空（甲方）【修改】" },
    { value: 40, label: "供应链便利店消费" },
    { value: 41, label: "供应链便利店退款" },
    { value: 42, label: "扫码点餐消费" },
    { value: 43, label: "扫码点餐退款" },
    { value: 44, label: "k12充值" },
    { value: 45, label: "k12退款" },
    { value: 50, label: "商城消费" },
    { value: 51, label: "商城退款" },
    { value: 52, label: "k12批量清零" },
    // 新增类型 by 冯橹宇 2024-02-04
    { value: 53, label: "电子充值" },
    { value: 54, label: "迁移充值" },
    { value: 55, label: "实体充值" },
    { value: 56, label: "电子消费" },
    { value: 57, label: "迁移消费" },
    { value: 58, label: "实体消费" },
    { value: 59, label: "电子退款" },
    { value: 60, label: "迁移退款" },
    { value: 61, label: "实体退款" },
    { value: 62, label: "红包消费" },
    { value: 63, label: "红包退款" },
    { value: 64, label: "三方支付" },
    { value: 65, label: "三方退款" },
    { value: 66, label: "余额卡密消费" },
    { value: 67, label: "余额卡密退款" },
    { value: 68, label: "红包充值" },
    // 新增类型 by 张丽娜 2024-06-22
    { value: 69, label: "卡密清零" },
    { value: 70, label: "卡密撤销" },
    { value: 71, label: "便利店线上消费" },
    { value: 72, label: "实体卡作废" },
    { value: 73, label: "卡密激活（仅实体卡）" },
    { value: 74, label: "注销清零" },
    { value: 75, label: "红包消费" },
    { value: 76, label: "红包退款" },
  ],
  // 新的交易类型
  // 商城卡密 - 卡片类型
  cardTypeExport: {
    1: "电子卡密",
    2: "迁移卡密",
    3: "实体卡密",
    4: "红包卡密"
  },
  // 商城卡密 - 卡片状态
  cardStatusExport: {
    0: "未激活",
    1: "已激活",
    2: "已作废",
    3: "已过期"
  },
  // 卡密类型
  cardTypes: {
    0: "余额卡密",
    1: "电子卡密",
    2: "迁移卡密",
    3: "实体卡密"
  },
  // 睿景商城 - 余额变动
  balanceTradeType: {
    66: "消费（余额）",
    1: "消费（卡密）",
    2: "消费（微信）",
    62: "消费（优惠券）",
    75: "消费（红包卡密）",
    67: "退款（余额）",
    3: "退款（卡密）",
    4: "退款（微信）",
    63: "退款（优惠券）",
    76: "退款（红包卡密）",
    53: "充值（电子卡密）",
    55: "充值（实体卡密）",
    54: "充值（迁移卡密）",
    68: "充值（红包卡密）",
    5: "充值（补偿赔付）",
    69: "清零（卡密）",
    74: "作废（注销卡密）",
    72: "作废",
    70: "撤销",
    77:'餐卡支付',
    78:'餐卡退款',
  },

  mallidArr2: [{ id: 1, label: '小快优品' }, { id: 2, label: '快客利家园' }],
  mallidObj2: { 1: '小快优品', 2: '快客利家园' },
  mallidArr: [{ id: 1, label: '小快优品(首创)' }, { id: 2, label: '小快优品(非首创)' }, { id: 3, label: '快客利家园' }],
  mallidObj: { 1: '小快优品(首创)', 2: '小快优品(非首创)', 3: '快客利家园' },
  signstatusObj: { 1: '发送中', 2: '发送完成', 3: '未调用' },
  ordertype: { 1: '平台', 2: '自营' },
  orderMType: { 1: '订单完成', 2: '退款成功' },
};

//module.exports = config;



//////////////////
// WEBPACK FOOTER
// ./statusConfig.js
// module id = t/xD
// module chunks = 49